<div class="container">
  <div class="header">
    <div class="monthContainer custom-dropdown">
      <p-dropdown [options]="months">
        <ng-template pTemplate="selectedItem">
          <span class="month-option selected">
            {{currentMonth}}</span>
        </ng-template>
        <ng-template let-month pTemplate="item">
          <span class="month-option" (click)="onMonthSelect(month)">{{month}}</span>
        </ng-template>
      </p-dropdown>
      <p-dropdown [options]="years">
        <ng-template pTemplate="selectedItem">
          <span class="month-option selected">
            {{currentYear}}
          </span>
        </ng-template>
        <ng-template let-year pTemplate="item">
          <span class="month-option" (click)="onYearSelect(year)">
            {{year}}
          </span>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="arrows">
      <div class="arrow" (click)="previousMonth()">
        <img class="left" src="../../../assets/Availabilities/arrow-left.svg">
      </div>
      <div class="arrow" (click)="nextMonth()">
        <img class="right" src="../../../assets/Availabilities/arrow-right.svg">
      </div>
    </div>
  </div>
  <div class="body">
    <div class="row days">
      <div class="case" *ngFor="let day of days"><span>{{day}}</span></div>
    </div>
    <ng-container *ngFor="let month of calendar.months; let index = index">
      <div class="calendar" *ngIf="currentMonthIndex === index">
        <div class="row" *ngFor="let week of month.weeks">
          <div class="case" *ngFor="let day of week.days" [class.otherMonth]="day.month !== currentMonthIndex"
            [class.today]="compareDates(day.date, currentDate) && day.dayNumber !== 1"
            [class.today1]="compareDates(day.date, currentDate) && day.dayNumber === 1" (click)="dayClick(day.date)">
            <div class="dayNumber" *ngIf="day.dayNumber">
              <span class="number">{{day.dayNumber}}</span>
              <span class="month-name" *ngIf="day.dayNumber === 1">{{getShortMonth(day.date)}}</span>
            </div>
            <div class="event" [class.event1]="e.calendarPosition === 0" [class.event2]="e.calendarPosition === 1"
              [class.isStart]="e.isStart" [class.isEnd]="e.isEnd"
              [class.downStairs]="e.type === ReservationType.Downstairs"
              [class.upStairs]="e.type === ReservationType.Upstairs" *ngFor="let e of day.events"
              (click)="eventClick($event, e)">
              <span *ngIf="showName(day, e)" class="name">{{e.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="footer">
    <div class="legend">
      <div class="color full"></div>
      <span>{{'Occupation Entière' | translate}}</span>
    </div>
    <div class="legend">
      <div class="color upStairs"></div>
      <span>{{'Occupation Partielle (Haut)' | translate}}</span>
    </div>
    <div class="legend">
      <div class="color downStairs"></div>
      <span>{{'Occupation Partielle (Bas)' | translate}}</span>
    </div>
    <div class="legend">
      <div class="color free"></div>
      <span>{{'Libre' | translate}}</span>
    </div>
  </div>
</div>